import React, { useState } from 'react';
import { Calendar, Clock, Flag, X } from 'lucide-react';

const TeamChallengeModal = ({ teamId, teamName, onClose, onCreateChallenge }) => {
  const [challengeData, setChallengeData] = useState({
    title: '',
    description: '',
    startDate: '',
    endDate: '',
    goalType: 'steps',
    goalValue: 100000
  });
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setChallengeData(prev => ({ ...prev, [name]: value }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onCreateChallenge({
      ...challengeData,
      id: Date.now(),
      progress: 0,
      teamId
    });
    onClose();
  };
  
  return (
    <div className="bg-white rounded-xl shadow-lg p-6 w-full">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">Create Team Challenge</h2>
        <button className="text-gray-500" onClick={onClose}>
          <X size={20} />
        </button>
      </div>
      
      <form onSubmit={handleSubmit}>
        <div className="space-y-4">
          <div>
            <label className="block text-gray-700 mb-1">Challenge Title</label>
            <input
              type="text"
              name="title"
              value={challengeData.title}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
              placeholder="e.g., 100K Steps Challenge"
              required
            />
          </div>
          
          <div>
            <label className="block text-gray-700 mb-1">Description</label>
            <textarea
              name="description"
              value={challengeData.description}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
              placeholder="Describe your team challenge"
              rows="3"
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700 mb-1">Start Date</label>
              <div className="relative">
                <span className="absolute left-3 top-2.5 text-gray-500">
                  <Calendar size={16} />
                </span>
                <input
                  type="date"
                  name="startDate"
                  value={challengeData.startDate}
                  onChange={handleChange}
                  className="w-full pl-10 p-2 border border-gray-300 rounded-md"
                  required
                />
              </div>
            </div>
            
            <div>
              <label className="block text-gray-700 mb-1">End Date</label>
              <div className="relative">
                <span className="absolute left-3 top-2.5 text-gray-500">
                  <Calendar size={16} />
                </span>
                <input
                  type="date"
                  name="endDate"
                  value={challengeData.endDate}
                  onChange={handleChange}
                  className="w-full pl-10 p-2 border border-gray-300 rounded-md"
                  required
                />
              </div>
            </div>
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700 mb-1">Goal Type</label>
              <select
                name="goalType"
                value={challengeData.goalType}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded-md"
              >
                <option value="steps">Steps</option>
                <option value="distance">Distance (km)</option>
                <option value="streak">Daily Streak</option>
              </select>
            </div>
            
            <div>
              <label className="block text-gray-700 mb-1">Goal Value</label>
              <div className="relative">
                <span className="absolute left-3 top-2.5 text-gray-500">
                  <Flag size={16} />
                </span>
                <input
                  type="number"
                  name="goalValue"
                  value={challengeData.goalValue}
                  onChange={handleChange}
                  className="w-full pl-10 p-2 border border-gray-300 rounded-md"
                  min="1"
                  required
                />
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex justify-end space-x-2 mt-6">
          <button
            type="button"
            className="px-4 py-2 border border-gray-300 rounded-md"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-primary text-white rounded-md"
          >
            Create Challenge
          </button>
        </div>
      </form>
    </div>
  );
};

export default TeamChallengeModal;